export const extractDeleteDocumentParams = (params) => {
  const {
    patient: {
      ins: {
        '@root': insRoot,
        '@extension': insExtension,
      },
    },
    submitEngine: {
      value: submitEngine,
    } = {},
    document: {
      uniqueId: {
        value: uniqueId,
      },
      uuid: {
        value: uuid,
      } = {},
      practice: {
        value: practice,
      } = {},
    },
  } = params;

  return {
    ins: insExtension + insRoot,
    uniqueId,
    uuid,
    practice,
    submitEngine,
  };
};

export const extractJSONDeleteDocumentParams = (params) => {
  const {
    patient: {
      ins: {
        root: insRoot,
        extension: insExtension,
      },
    },
    submitEngine,
    document: {
      uniqueId,
      uuid,
      practice,
    },
  } = params;

  return {
    ins: insExtension + insRoot,
    uniqueId,
    uuid,
    practice,
    submitEngine,
  };
};
